// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-list__container {
    padding: calc( var( --space )  );
    background-color: var( --white-color );
    margin: var( --space ) auto;
    box-shadow: var( --shadow-card-2 );
    border-radius: 14px;
    width: 85%;
}

.tournament-list__title.baloa-normal-medium{
    color: var(--primary-dark-color);
    padding-bottom: var(--space);
    padding-left: var(--space-half);
}

.tournament-list__container__card {
    width: 100%;
    /* padding: var( --space ) var( --space-half ) ; */
    padding-left: calc(var(--space-and-half) + var(--space-half) - 2px);
    padding-bottom: var(--space-x2);
    background-color: var( --white-color );
    /* margin-bottom: calc( var( --space ) + var( --space-half )); */
    /* margin-bottom: var(--space-half); */
    /* box-shadow: var( --shadow-card-2 ); */
    display: flex;
    align-items: center;
    justify-content: space-between;    
}

.tournament-list__container__card:hover {
    cursor: pointer;
}

.tournament-list__container__card__info{
    display: flex;
    align-items: center;
}

/* .tournament-list__container__card__info__detail{
    max-height: var(--space-x2);
    flex-grow: 1;
} */

.tournament-list__container__card__info p {
    margin-bottom: var(--space-quarter);
    display:grid;
}

.tournament-list__container__card__info .icon-trophy{
    /* width: calc(var(--space-x2) + var(--space-half));
    height: calc(var(--space-x2) + var(--space-half));
    min-width: var(--space-x2);
    min-height: var(--space-x2);
    position: relative;
    overflow: hidden;
    margin-right: var(--space-half);
    margin-top: calc(var(--space-half) * 1.5);
    padding: var(--space-quarter); */
    font-size: 30px;
    color: var(--basic-gray-color);
    margin-right: var(--space);
}

.tournament-list__container__card:last-child{
    padding-bottom: 0;
}

.league_tournament_list_container{
    /* margin-top: var(--space-x2); */
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-tournaments-list-component/LeagueTournamentsListComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,2BAA2B;IAC3B,kCAAkC;IAClC,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,kDAAkD;IAClD,mEAAmE;IACnE,+BAA+B;IAC/B,sCAAsC;IACtC,gEAAgE;IAChE,sCAAsC;IACtC,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;GAGG;;AAEH;IACI,mCAAmC;IACnC,YAAY;AAChB;;AAEA;IACI;;;;;;;;oCAQgC;IAChC,eAAe;IACf,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;AACrC","sourcesContent":[".tournament-list__container {\n    padding: calc( var( --space )  );\n    background-color: var( --white-color );\n    margin: var( --space ) auto;\n    box-shadow: var( --shadow-card-2 );\n    border-radius: 14px;\n    width: 85%;\n}\n\n.tournament-list__title.baloa-normal-medium{\n    color: var(--primary-dark-color);\n    padding-bottom: var(--space);\n    padding-left: var(--space-half);\n}\n\n.tournament-list__container__card {\n    width: 100%;\n    /* padding: var( --space ) var( --space-half ) ; */\n    padding-left: calc(var(--space-and-half) + var(--space-half) - 2px);\n    padding-bottom: var(--space-x2);\n    background-color: var( --white-color );\n    /* margin-bottom: calc( var( --space ) + var( --space-half )); */\n    /* margin-bottom: var(--space-half); */\n    /* box-shadow: var( --shadow-card-2 ); */\n    display: flex;\n    align-items: center;\n    justify-content: space-between;    \n}\n\n.tournament-list__container__card:hover {\n    cursor: pointer;\n}\n\n.tournament-list__container__card__info{\n    display: flex;\n    align-items: center;\n}\n\n/* .tournament-list__container__card__info__detail{\n    max-height: var(--space-x2);\n    flex-grow: 1;\n} */\n\n.tournament-list__container__card__info p {\n    margin-bottom: var(--space-quarter);\n    display:grid;\n}\n\n.tournament-list__container__card__info .icon-trophy{\n    /* width: calc(var(--space-x2) + var(--space-half));\n    height: calc(var(--space-x2) + var(--space-half));\n    min-width: var(--space-x2);\n    min-height: var(--space-x2);\n    position: relative;\n    overflow: hidden;\n    margin-right: var(--space-half);\n    margin-top: calc(var(--space-half) * 1.5);\n    padding: var(--space-quarter); */\n    font-size: 30px;\n    color: var(--basic-gray-color);\n    margin-right: var(--space);\n}\n\n.tournament-list__container__card:last-child{\n    padding-bottom: 0;\n}\n\n.league_tournament_list_container{\n    /* margin-top: var(--space-x2); */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
